import { createContext } from 'react';
import { EapSettingsFormModelValidationModel } from '../settings-devices-eap-settings-form.model';

export interface EapSettingsFormValidationContextType {
    errors?: EapSettingsFormModelValidationModel;
}

export const EapSettingsFormValidationContext = createContext<EapSettingsFormValidationContextType | undefined>(
    undefined
);
